import { c as _c } from "react/compiler-runtime";
import { useRoleXgSeat } from "@hooks/use-role-xg-seat";
import { FaroCoreApiConst } from "@stellar/core-api-client";
import { GroupMemberEvents } from "@utils/track-event/track-event-list";
import { doesWorkspaceRoleRequireXgSeat } from "@utils/xg-seat-utils";
/** The group roles that need a Sphere XG seat: group managers and project managers */
export const GROUP_ROLE_XG_SEAT = {
  xgSeatRoles: FaroCoreApiConst.allGroupRoles.filter(role => doesWorkspaceRoleRequireXgSeat(role)),
  viewerRole: "GROUP_VIEWER",
  events: GroupMemberEvents
};

/**
 * Applies the Sphere XG seats to changing the role of a group member, see useRoleXgSeat. On a Scan
 * plan, only members holding a seat can be group managers or project managers.
 */
export function useGroupRoleXgSeat(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = {
      ...props,
      subject: GROUP_ROLE_XG_SEAT
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useRoleXgSeat(t0);
}